/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, GridItem, SimpleGrid, VStack } from '@chakra-ui/react';
import { useGetBooksMutation } from '@partiu/api/bookstore/hooks';
import { IBook, PaginatedResponse, Params } from '@partiu/api/types';
import { useEffect, useState } from 'react';
import { FaFrown } from 'react-icons/fa';
import { UseMutationOptions, UseMutationResult } from 'react-query';
import { InfiniteScroll } from '../../../../../packages/ui/components/atoms/InfiniteScroll';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { BookCard } from '../molecules/BookCard';

export function BookGrid({
  filters = {},
  mutationHook = useGetBooksMutation,
}: {
  filters?: Params;
  mutationHook?: (
    options: UseMutationOptions<PaginatedResponse<IBook>, unknown, Params, unknown>
  ) => UseMutationResult<PaginatedResponse<IBook>, unknown, Params, unknown>;
}) {

  const { id, bookstoreLabels } = useTheme();
  const [hookProps, setHookProps] = useState<Params>(filters);

  useEffect(() => {
    setHookProps({ ...filters });
  }, [filters]);

  if (!id) return <></>;

  return (
    <Box w={'100%'} mt="20px" paddingBottom={'80px'}>
      <InfiniteScroll
        filterMagazine={filters?.type === 'magazine'}
        keyExtraction={(book) => book.id.toString()}
        renderItem={(book: any) => (
          <GridItem>
            <BookCard grid isActive={false} book={book.book ? book.book : book} />
          </GridItem>
        )}
        emptyResultsComponent={
          <VStack paddingTop={'50px'} spacing={5}>
            <FaFrown size="36px" />
            <SectionTitle color="black">Nenhum item encontrado!</SectionTitle>
          </VStack>
        }
        mutationHook={mutationHook}
        hookProps={hookProps}
      >
        {(items) => (
          <SimpleGrid gap={3} spacing={0} columns={{ base: 2, lg: 6 }}>
            {items}
          </SimpleGrid>
        )}
      </InfiniteScroll>
    </Box>
  );
}
